/* eslint-disable max-len */

import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../common-utils/libraries/axios/axios';

import { buildUrl } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import simCardFields from '../../fields/simCardFields';
import { SIM_CARDS } from '../apiUrls';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.label string
 * @param responseData.provider string
 * @param responseData.status string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param response
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [simCardFields.UUID.key]: item[simCardFields.UUID.key],

            [simCardFields.SIM_CARD.key]: {
                [simCardFields.SIM_CARD.STATUS.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.STATUS)),
                [simCardFields.SIM_CARD.LABEL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.LABEL)),
                [simCardFields.SIM_CARD.ICCID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.ICCID)),
                [simCardFields.SIM_CARD.ICCID_OPERATOR.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.ICCID_OPERATOR)),
                [simCardFields.SIM_CARD.DATA.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.DATA)),
                [simCardFields.SIM_CARD.DATA_USAGE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.DATA_USAGE)),
                [simCardFields.SIM_CARD.DATA_UNIT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.DATA_UNIT)),
                [simCardFields.SIM_CARD.TARIFF_NAME.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.TARIFF_NAME)),
                [simCardFields.SIM_CARD.CREATED_AT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.CREATED_AT)),
                [simCardFields.SIM_CARD.UPDATED_AT.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.UPDATED_AT)),
                [simCardFields.SIM_CARD.CANCELLATION_DATE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.CANCELLATION_DATE)),
                [simCardFields.SIM_CARD.ACTIVATION_DATE.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.ACTIVATION_DATE)),
                [simCardFields.SIM_CARD.NEXT_OFFER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.NEXT_OFFER)),
                [simCardFields.SIM_CARD.NEXT_ICCID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.NEXT_ICCID)),
                [simCardFields.SIM_CARD.UUID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.UUID)),
                [simCardFields.SIM_CARD.OFFER_CAN_BE_UPDATED.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.OFFER_CAN_BE_UPDATED)),

                [simCardFields.SIM_CARD.POS_TERMINAL.key]: {
                    [simCardFields.SIM_CARD.POS_TERMINAL.SERIAL_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.POS_TERMINAL.SERIAL_NUMBER)),
                    [simCardFields.SIM_CARD.POS_TERMINAL.MANUFACTURER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.POS_TERMINAL.MANUFACTURER)),
                    [simCardFields.SIM_CARD.POS_TERMINAL.LAST_GPRS_CALL.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.SIM_CARD.POS_TERMINAL.LAST_GPRS_CALL))
                }
            },
            [simCardFields.CLIENT.key]: {
                [simCardFields.CLIENT.LEGAL_NAME.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(simCardFields.CLIENT.LEGAL_NAME))
            }
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetSimCards = (query, enabled) => {
    return {
        queryKey: [SIM_CARDS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(SIM_CARDS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetSimCards;